module.exports = {
  LOGIN: 'login_sucess',
  USER_DETAILS: 'get_user_details',
  GET_USER_DETAIL: 'get_user_detail'
};
